function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.date.to-json.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.function.bind.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import Layer from '@mozaic-ds/freemarker/js/modules/_layer.js';
import { hitEventTms } from 'integration-web-core--socle/js/assets/commons/_tms';
import { cdlEvent, customerHeaderModuleCollaboratorClickEvent } from './trackingEvents';
var CustomerHeaderModule = /*#__PURE__*/function (_lm$Composant) {
  function CustomerHeaderModule(id) {
    _classCallCheck(this, CustomerHeaderModule);
    return _callSuper(this, CustomerHeaderModule, [id]); // Init code
  }
  _inherits(CustomerHeaderModule, _lm$Composant);
  return _createClass(CustomerHeaderModule);
}(lm.Composant);
var CustomerHeaderModuleV2 = /*#__PURE__*/function (_lm$Composant2) {
  function CustomerHeaderModuleV2(id) {
    var _this;
    _classCallCheck(this, CustomerHeaderModuleV2);
    _this = _callSuper(this, CustomerHeaderModuleV2, [id]);
    var customerNameElement = document.querySelector('.customerheadermodule__label.connected');
    if (customerNameElement) {
      /*
       The local storage key 'customerFirstName' is set by customer-space-module when customer updates its first name
       Whenever the component is rendered in connected mode, it will not acknowledge the change of the customer firstname from the customer space application
       It causes desync that the bellow implementation is fixing
      */
      var localStorageCustomerFirstName = localStorage.getItem('customerFirstName');
      if (localStorageCustomerFirstName) {
        customerNameElement.textContent = localStorageCustomerFirstName;
      }
      customerNameElement.classList.add("kl-visible@from-l");
    } else {
      localStorage.removeItem('customerFirstName');
    }
    return _this;
  }
  _inherits(CustomerHeaderModuleV2, _lm$Composant2);
  return _createClass(CustomerHeaderModuleV2);
}(lm.Composant);
var ShoppingListHeaderModule = /*#__PURE__*/function (_lm$Composant3) {
  function ShoppingListHeaderModule(id) {
    _classCallCheck(this, ShoppingListHeaderModule);
    return _callSuper(this, ShoppingListHeaderModule, [id]); // Init code
  }
  _inherits(ShoppingListHeaderModule, _lm$Composant3);
  return _createClass(ShoppingListHeaderModule);
}(lm.Composant);
lm.DOMReady(function () {
  var customerHeaderModuleComponent = document.querySelector('.component-customerheadermodule');
  if (window.ACTIVATE_LAYER === 'true') {
    var layer = new Layer({
      'classContent': 'customer-header-layer-info',
      'isScrollEdge': false
    });
    customerHeaderModuleComponent.addEventListener('mouseover', function () {
      layer.open();
    });
    var closeInfoLayer = document.querySelector('.js-close-layer-info');
    closeInfoLayer.addEventListener('click', function () {
      layer.close();
    });
  }
  var customerHeaderModuleCollaboratorLink = document.querySelector('.customerheadermodule__link.collaborator');
  if (customerHeaderModuleCollaboratorLink) {
    customerHeaderModuleCollaboratorLink.addEventListener('click', function () {
      console.log("Tracking event sent - " + JSON.stringify(customerHeaderModuleCollaboratorClickEvent));
      hitEventTms(customerHeaderModuleCollaboratorLink, cdlEvent, JSON.stringify(customerHeaderModuleCollaboratorClickEvent));
    });
  }
  var CustomerHeaderModuleModule = new CustomerHeaderModule('customerheadermodule');
  var CustomerHeaderModuleModuleV2 = new CustomerHeaderModuleV2('customerheadermodulev2');
  var ShoppingListHeaderModuleModule = new ShoppingListHeaderModule('shoppinglistheadermodule');
});